import { createAction } from 'redux-actions';
import { createHttpActions } from '../../redux/http-descriptor';

export const APP_SET_HOLDING_COMPANY = 'APP_SET_HOLDING_COMPANY';
export const PRODUCTS_DELETE_ITEM_IMAGE = 'PRODUCTS_DELETE_ITEM_IMAGE';

export default {
  importCarData: createAction(createHttpActions('carDataImport').request),
  resetImportCarData: createAction(createHttpActions('carDataImport').reset),
  setItemForCarDataImport: createAction(createHttpActions('carDataImportItem', 'put').request),
  setHoldingCompany: createAction(APP_SET_HOLDING_COMPANY),
  deleteItemImage: createAction(PRODUCTS_DELETE_ITEM_IMAGE),
};
